import React from "react";
import BannerCms from "../components/BannerCms";
import CtaSection from "../components/CtaSection";

const Privacy = () => {
  return (
    <>
      <BannerCms
        title="Privacy Policy"
        subtitle="We care about your privacy"
        description="Your privacy is important to us at Untitled. We respect your privacy regarding any information we may collect from you across our website."
      />
      <section className="policy-content">
        <div className="container">
          <p>
            Welcome to Pegiora Inc. ("Company," "we," "us," or
            "our"). This Privacy Policy is designed to inform you about how we
            collect, use, disclose, and safeguard your personal information when
            you interact with our mobile application and website ("Platform").
            This includes, but is not limited to, the use of our courier
            delivery services ("Services"). Please read this Privacy Policy
            carefully to understand our policies and practices regarding your
            information and how we will treat it.
          </p>
          <h3> Scope of Policy</h3>
          <p>
            This Privacy Policy applies to all users ("Users," "you," or "your")
            who access or use our Platform and Services. This includes any data
            you may provide when you sign up for an account, use our Services,
            post content, or communicate with us through the Platform or any
            other means. This Policy applies to all information collected
            through the Platform and any affiliated services or tools.
          </p>
          <h3> Acceptance of Privacy Policy</h3>
          <p>
            By accessing or using the Platform and Services, you acknowledge
            that you have read, understood, and agree to be bound by the terms
            of this Privacy Policy and our Terms and Conditions. If you do not
            agree with our policies and practices, your choice is to discontinue
            using our Platform and Services. Your continued use of the Platform
            following the posting of changes to this Privacy Policy will be
            deemed your acceptance of those changes.
          </p>
          <h3>Information Collected</h3>
          <p>
            We collect various types of information to provide and improve our
            Services. This includes:
          </p>
          <ul>
            <li>
              <b>Personal Information:</b> Such as your name, email address,
              phone number, and other identifying information that you may
              provide during the account creation process.
            </li>
            <li>
              <b>Usage Information:</b> Such as your IP address, browser type,
              the pages you visit, the time and date of your visit, and other
              diagnostic data. This information helps us to improve the
              functionality and user experience of our Platform.
            </li>
          </ul>
          <h3> How Information is Collected</h3>
          <p>
            We collect information through various methods, which may include
            but are not limited to:
          </p>
          <ul>
            <li>
              Directly from You: When you voluntarily provide information by
              filling out forms on the Platform, such as during the account
              registration process.
            </li>
            <li>
              Automatically: Through the use of cookies, log files, and other
              tracking technologies. These technologies collect certain types of
              information automatically when you use our Platform.
            </li>
          </ul>
          <h3> Use of Information</h3>
          <p>
            The information we collect serves multiple purposes, including but
            not limited to:
          </p>
          <ul>
            <li>
              <b>Service Provision: </b>To provide, maintain, and improve the
              Services, including to process transactions, subscriptions, and
              customer service inquiries.
            </li>
            <li>
              <b>Communication: </b>To communicate with you about updates,
              promotions, and customer service inquiries, and to respond to your
              comments or questions.
            </li>
            <li>
              <b>Legal Obligations: </b>To comply with applicable legal
              requirements and protect against legal claims, to protect the
              rights and property of the Company, Users, and third parties, and
              to enforce our Terms and Conditions
            </li>
          </ul>
          <h3>Sharing of Information</h3>
          <p>
            We may share your personal information with third parties under
            certain circumstances, including but not limited to:
          </p>
          <ul>
            <li>
              <b>Service Providers:</b>Third-party vendors and service providers
              that perform services on our behalf, such as payment processing
              and data analysis.
            </li>
            <li>
              <b>Legal Requirements:</b>To comply with laws, regulations, legal
              processes, or governmental requests.
            </li>
            <li>
              <b>Consent:</b>With your explicit consent or at your direction,
              such as when you choose to share information with third-party
              services through our Platform.
            </li>
          </ul>
          <h3>Third-Party Services</h3>
          <p>
            Our Platform may contain links to third-party websites,
            applications, or services that are not owned or controlled by 
            Pegiora Inc. This Privacy Policy does not apply to the
            practices of these third parties. We strongly recommend that you
            read the privacy policies of any third-party platforms you visit or
            use.
          </p>
          <h3> User Rights </h3>
          <p>
            As a user of our Platform, you have certain rights concerning your
            personal information. These rights may include accessing,
            correcting, updating, or deleting your personal information. You may
            also have the right to object to or restrict certain types of
            processing of your personal information and to receive a copy of
            your personal information in a portable format.
          </p>
          <h3> Data Security</h3>
          <p>
            We take the security of your personal information seriously and use
            various security measures to protect it. These measures include, but
            are not limited to, the use of secure servers, firewalls, and
            encryption technologies. However, no method of electronic storage or
            transmission is 100% secure, and we cannot guarantee the absolute
            security of your personal information.if your want to delete your account 
             <a
              href="/DeleteAccount"
              // target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              &nbsp;Click Here&nbsp;
            </a>.
          </p>
          <h3>Data Retention</h3>
          <p>
                      We retain your personal information, including your location data, payment transaction details,
                      and device information, only for as long as it is necessary to fulfill the purposes for which it 
                      was collected, such as providing services, complying with legal obligations, or for analytical purposes.
                      The retention period varies depending on the type of data and the specific purpose, but in all cases, 
                      we securely delete or anonymize your data once it is no longer needed. We collect your location data 
                      through the app to enhance user experience and provide relevant content. We also collect payment details 
                      securely for processing transactions and do not store sensitive payment information beyond the transaction
                      process. To ensure transparency, we have updated the privacy policy to clearly explain how we handle, 
                      store, and delete sensitive user data, including location and payment information, and emphasize that 
                      all personal data is removed once the purpose is fulfilled or if the user deletes their account. 
                      This aligns with Google Play Store policies on user data privacy, emphasizing user control and 
                      data security.
                    </p>
                    <h3>Location Data</h3>
          <p>
            We collect and process location data to enable and enhance the core functionality 
            of our services. This includes determining pickup and delivery locations, providing 
            accurate courier tracking, route optimization, and service availability in your area.
          </p>
          <ul>
            <li>
              <b>Type of Location Data Collected:</b> We may collect your precise (GPS-based) or 
              approximate (network-based) location when you use our mobile app. The level of accuracy 
              depends on your device settings and permissions.
            </li>
            <li>
              <b>Purpose of Collection:</b> Location data is used only to facilitate courier delivery, 
              optimize routes, provide real-time tracking, and enhance safety and customer support.
            </li>
            <li>
              <b>User Control:</b> You can manage or revoke location permissions at any time 
              through your device’s settings. However, disabling location access may affect 
              certain app functionalities such as live delivery updates or nearby service availability.
            </li>
            <li>
              <b>Data Retention:</b> Location data is retained only for as long as necessary to 
              fulfill delivery operations and improve service performance. Once no longer needed, 
              it is securely deleted or anonymized.
            </li>
            <li>
              <b>Sharing:</b> We do not share your precise location with third parties for marketing 
              or advertising. Location data is shared only with authorized logistics partners 
              or drivers strictly for operational purposes.
            </li>
          </ul>

          <h3>Children's Privacy (COPPA)</h3>
          <p>
            Our Platform and Services are not intended for use by children under
            the age of 13, and we do not knowingly collect personal information
            from children under 13. If we become aware that we have collected
            personal information from a child under the age of 13, we will take
            steps to remove that information and terminate the child's account.
          </p>
          <h3>California Consumer Privacy Act (CCPA)</h3>
          <p>
            If you are a California resident, you have specific rights under the
            California Consumer Privacy Act. These rights include the right to
            know what personal information is collected, the right to delete
            personal information, and the right to opt-out of the sale of
            personal information. For more details, please refer to our
            CCPA-specific section.
          </p>
          <h3>International Data Transfers</h3>
          <p>
            Your personal information may be transferred to and processed in
            countries other than the country in which you are a resident. These
            countries may have data protection laws that differ from those of
            your country. We take appropriate measures to ensure that your
            personal information remains protected in accordance with this
            Privacy Policy.
          </p>
          <h3>Legal Requirements </h3>
          <p>
            We may disclose your personal information where required by law or
            legal process, such as to comply with a subpoena or similar legal
            process, when we believe in good faith that disclosure is necessary
            to protect our rights, protect your safety or the safety of others,
            or to investigate fraud.
          </p>
          <h3> Changes to Privacy Policy</h3>
          <p>
            We reserve the right to update or modify this Privacy Policy at any
            time and for any reason. Any changes or modifications will be
            effective immediately upon posting the updated Privacy Policy on the
            Platform. Your continued use of the Platform after any such changes
            constitutes your acceptance of the new Privacy Policy.
          </p>
          <h3>Opt-Out Options </h3>
          <p>
            You may have the option to opt-out of receiving marketing
            communications from us. To do so, you can follow the opt-out links
            on any marketing message sent to you or contact us directly. Please
            note that even if you opt-out, we may still send you non-promotional
            communications, such as those about your account or ongoing business
            relations.
          </p>
          <h3>Governing Law </h3>
          <p>
            This Privacy Policy is governed by and construed in accordance with
            the laws of the State of Ohio, without regard to its conflict of law
            principles. Any disputes arising from or relating to this Privacy
            Policy shall be resolved in the jurisdiction of the State of Ohio.
          </p>
          <h3> Dispute Resolution </h3>
          <p>
            Any disputes arising out of or relating to this Privacy Policy or
            the Platform will be resolved through binding arbitration, rather
            than in court, except for matters that can be taken to small claims
            court. The arbitration will be conducted in the State of Ohio, and
            judgment on the arbitration award may be entered into any court
            having jurisdiction thereof.
          </p>
          <h3>Effective Date</h3>
          <p>
            This Privacy Policy is effective as of 1st October 2023, and will
            remain in effect unless and until it is updated or modified in
            accordance with Section 16 of this Policy.
          </p>
          <h3> Contact Information </h3>
          <p>
            For any questions or concerns regarding this Privacy Policy, please
            contact us at.
            <a
              href="mailto:info@pegioralogistics.com."
              target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              &nbsp; info@pegioralogistics.com
            </a>
          </p>

          <hr />
          <h3 className="text-center">COOKIE POLICY</h3>

          <h3>Introduction</h3>
          <p>
            Welcome to Pegiora Inc. ("Company," "we," "us," or
            "our"). This Cookie Policy explains how we use cookies and similar
            technologies to recognize you when you visit our mobile application
            and website ("Platform"). It explains what these technologies are
            and why we use them, as well as your rights to control our use of
            them.
          </p>

          <h3>What Are Cookies?</h3>
          <p>
            Cookies are small data files that are placed on your computer or
            mobile device when you visit a website or use an online service.
            Cookies are widely used by online service providers to facilitate
            and help to make the interaction between users and websites, mobile
            apps, and online services faster and easier, as well as to provide
            reporting information.
          </p>

          <h3>Types of Cookies We Use</h3>
          <p>
            We use several types of cookies on our Platform, including but not
            limited to:
          </p>
          <ul>
            <li>
              <b>Session Cookies:</b> These are temporary cookies that expire
              when you close your browser or app.
            </li>
            <li>
              <b>Persistent Cookies:</b> These cookies remain on your device for
              a set period or until you delete them.
            </li>
            <li>
              <b>Third-Party Cookies:</b> These are cookies set by third parties
              that we may use for various services, such as analytics or
              advertising.
            </li>
          </ul>

          <h3>Why We Use Cookies</h3>
          <p>
            Cookies play an important role in helping us provide a personalized
            experience to you. Here are some of the ways we use cookies:
          </p>
          <ul>
            <li>
              <b>To Authenticate Users:</b> Cookies help us identify users so
              that you don't have to log in each time you visit our Platform.
            </li>
            <li>
              <b>To Improve Platform Performance:</b> Cookies can also be used
              to speed up your future activities and experiences on our
              Platform.
            </li>
            <li>
              <b>For Analytics:</b> We use cookies to understand user behavior
              and improve our Platform based on these insights.
            </li>
          </ul>

          <h3>Your Choices Regarding Cookies</h3>
          <p>
            You have the right to decide whether to accept or reject cookies.
            Most web browsers automatically accept cookies, but you can usually
            modify your browser setting to decline cookies if you prefer. If you
            choose to reject cookies, you may still use our Platform though your
            access to some functionality and areas may be restricted.
          </p>

          <h3>How to Control Cookies</h3>
          <p>
            There are several ways to manage cookies and other tracking
            technologies. You can clear cookies from your browser, or change
            your browser settings to either reject all cookies or to receive a
            notification when a cookie is being placed on your device. For
            detailed instructions, please refer to your browser’s help menu.
          </p>

          <h3>Third-Party Cookies</h3>
          <p>
            In some instances, we may use third-party cookies for purposes such
            as analytics, advertising, and social media interactions. These
            third-party cookies are governed by the respective third parties'
            privacy and cookie policies, and we recommend that you read their
            policies for more information.
          </p>

          <h3>Cookies and Personal Data</h3>
          <p>
            Cookies themselves do not typically contain personal information.
            However, we may link the information we store in cookies to any
            personally identifiable information you submit while using our
            Platform. This helps us personalize your experience.
          </p>

          <h3>Changes to This Cookie Policy</h3>
          <p>
            We may update this Cookie Policy from time to time to reflect
            changes to the cookies we use or for other operational, legal, or
            regulatory reasons. Any changes will be posted on this page, and
            your continued use of our Platform after such changes have been
            posted will constitute your acknowledgment of the modified Cookie
            Policy.
          </p>

          <h3>Contact Us</h3>
          <p>
            If you have any questions or concerns about our use of cookies or
            this Cookie Policy, you can contact us at
            <a
              href="mailto:info@pegioralogistics.com"
              target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              info@pegioralogistics.com
            </a>
          </p>

          <hr />
          <h3 className="text-center">SHIPPING AND REFUND POLICY</h3>
          <p>
            <h3>Introduction</h3>
            Welcome to Pegiora Inc. ("Company," "we," "us," or
            "our"). This combined Shipping and Refund Policy ("Policy") governs
            the shipping and refund practices related to the courier delivery
            services ("Services") offered through our mobile application and
            website ("Platform"). By using our Platform and Services, you
            ("User," "you," or "your") agree to comply with and be bound by the
            terms and conditions set forth in this Policy.
          </p>
          <p>
            <h3>Scope of Services</h3>
            This Policy applies to all shipping services provided by Pegiora
            Inc., including but not limited to, local, national, and
            future international shipping services. Our Services facilitate the
            transportation of goods, including medical supplies and e-commerce
            products, but exclude the delivery of food items. By using our
            Services, you acknowledge that you have read and understood the
            scope and limitations of the services we offer.
          </p>
          <p>
            <h3>Shipping Rates</h3>
            Shipping rates are calculated based on various factors, including
            the distance of the shipment, the weight and dimensions of the
            package, and any additional services you may select. All shipping
            rates are subject to change at our sole discretion, and we reserve
            the right to apply surcharges or offer discounts as we deem
            appropriate. You agree to pay all applicable shipping rates and
            charges as calculated at the time of your shipment.
          </p>
          <p>
            <h3>Delivery Timeframes</h3>
            We strive to deliver shipments within the timeframes indicated at
            the time of booking. However, delivery timeframes are estimates and
            are not guaranteed. Factors such as weather conditions, traffic, and
            other unforeseen circumstances may affect delivery times. We shall
            not be liable for any delays in delivery that are beyond our
            reasonable control.
          </p>
          <p>
            <h3>Packaging Requirements</h3>
            You are responsible for adequately packaging your items to ensure
            their safe and secure delivery. Packaging must comply with any
            applicable laws and regulations and should be suitable for the type
            of goods being shipped. Failure to comply with proper packaging
            requirements may result in the refusal of your shipment, and we
            shall not be liable for any loss or damage arising from inadequate
            packaging.
          </p>
          <p>
            <h3>Tracking and Notifications</h3>
            Upon confirmation of your shipment, you will receive a tracking
            number that allows you to monitor the status of your shipment
            through our Platform. We may also send notifications regarding the
            status of your shipment, including but not limited to, pickup,
            in-transit updates, and delivery confirmations. You agree to provide
            accurate contact information to facilitate such notifications.
          </p>
          <p>
            <h3>Restricted Items</h3>
            We maintain a list of items that are restricted from shipment
            through our Services. This list includes, but is not limited to,
            hazardous materials, illegal substances, and perishable goods. You
            are responsible for ensuring that your shipment does not contain any
            restricted items, and we reserve the right to refuse or terminate
            any shipment containing restricted items, without liability.
          </p>
          <p>
            <h3>Cancellation and Modification</h3>
            You may request the cancellation or modification of a shipment prior
            to its dispatch. However, cancellation or modification fees may
            apply depending on the timing and nature of the changes. We reserve
            the right to accept or reject any cancellation or modification
            requests at our sole discretion. No refunds will be issued for
            shipments that have already been dispatched.
          </p>
          <p>
            <h3>Eligibility for Refunds</h3>
            Refunds may be issued under specific circumstances, such as failure
            to deliver within a significantly delayed timeframe that is not due
            to force majeure events, or loss of goods due to our negligence.
            Refunds are not automatic and must be requested in accordance with
            the procedures outlined in this Policy.
          </p>
          <p>
            <h3>Timeframe for Filing a Refund</h3>
            All refund requests must be submitted within seven (7) days from the
            date of the scheduled delivery. Failure to submit a refund request
            within this timeframe will result in forfeiture of your eligibility
            for a refund.
          </p>
          <p>
            <h3>Processing of Refunds</h3>
            Upon approval of a refund request, the refund will be processed
            using the original payment method within fourteen (14) business
            days. We reserve the right to deduct any applicable fees or charges
            before issuing a refund.
          </p>
          <p>
            <h3>Non-refundable Services</h3>
            Certain services and fees are non-refundable, including but not
            limited to, rush delivery fees, special handling fees, and any other
            additional services that are successfully rendered.
          </p>
          <p>
            <h3>Liability for Damaged or Lost Items</h3>
            We shall not be liable for any loss or damage to items that are
            improperly packaged, fragile, or not suitable for transport. Our
            liability for lost or damaged items is limited to the lesser of the
            actual value of the item or the coverage amount selected at the time
            of shipment, subject to applicable laws and regulations.
          </p>
          <p>
            <h3>Indemnification Clause</h3>
            You agree to indemnify, defend, and hold harmless Pegiora Inc.,
             its officers, directors, employees, and agents.
          </p>
          <p>
            <h3>Governing Law</h3>
            This Policy, and any dispute or claim arising out of or in
            connection with it or its subject matter or formation, shall be
            governed by, and construed in accordance with, the laws of the State
            of Ohio. You irrevocably agree that the courts of the State of Ohio
            shall have exclusive jurisdiction to settle any dispute or claim
            that arises out of or in connection with this Policy or its subject
            matter or formation.
          </p>
          <p>
            <h3>Dispute Resolution</h3>
            Any disputes or claims arising out of or in connection with this
            Policy shall be resolved through final and binding arbitration,
            rather than in court. The arbitration shall be conducted in the
            State of Ohio, under the then-current rules of the American
            Arbitration Association. Judgment on the arbitration award may be
            entered into any court having jurisdiction thereof.
          </p>
          <p>
            <h3>Changes to Policy</h3>
            We reserve the right, at our sole discretion, to modify, add, or
            remove portions of this Policy at any time. Changes will become
            effective immediately upon being posted on our Platform. Your
            continued use of our Services following the posting of changes to
            this Policy will be deemed your acceptance of those changes.
          </p>
          <p>
            <h3>Contact Information</h3>
            For any questions, comments, or concerns regarding this Policy, you
            may contact us at{" "}
            <a
              href="mailto:info@pegioralogistics.com"
              target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              info@pegioralogistics.com
            </a>
          </p>

          <hr />
          <h3 className="text-center">COPYRIGHTS POLICY</h3>
        
            <h3>Introduction</h3>
            <p>
            Welcome to Pegiora Inc. ("Company," "we," "us," or
            "our"). This Copyright Policy ("Policy") is designed to inform you
            about our practices regarding the protection of our intellectual
            property, including but not limited to our mobile application,
            website, and other digital assets ("Platform"). By accessing or
            using our Platform, you ("User," "you," or "your") agree to respect
            our intellectual property rights and comply with the terms and
            conditions set forth in this Policy.
          </p>
            <h3>Ownership of Intellectual Property</h3>
            <p>
            All content, features, and functionality on our Platform, including
            but not limited to text, graphics, logos, icons, images, audio
            clips, and software, are the exclusive property of Pegiora Inc.
            and are protected by United States and international
            copyright laws.
          </p>
            <h3>Prohibition Against Unauthorized Use</h3>
            <p>
            Unauthorized copying, modification, distribution, public display, or
            public performance of any part of our Platform is strictly
            prohibited. Any use of our Platform that violates the terms of this
            Policy may be considered an infringement of our intellectual
            property rights and may subject you to legal action.
          </p>
          <p>
            <h3>Reporting Unauthorized Use</h3>
            If you become aware of any unauthorized use or infringement of our
            intellectual property, you are obligated to promptly notify us.
            Reports should be submitted to our designated agent at{" "}
            <a
              href="mailto:info@pegioralogistics.com"
              target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              info@pegioralogistics.com
            </a>
          </p>
          <p>
            <h3>Legal Actions and Remedies</h3>
            We reserve the right to take any and all legal actions necessary to
            enforce our intellectual property rights, including but not limited
            to seeking injunctive relief, damages, attorney's fees, and court
            costs against any individual or entity that violates this Policy.
          </p>
          <p>
            <h3>Indemnification</h3>
            You agree to indemnify, defend, and hold harmless Pegiora Inc.,
             its officers, directors, employees, agents,
            licensors, and suppliers from and against all losses, expenses,
            damages, and costs, including reasonable attorneys' fees, resulting
            from any violation of this Policy or any activity related to your
            use of the Platform.
          </p>
          <p>
            <h3>Governing Law and Jurisdiction</h3>
            This Policy shall be governed by and construed in accordance with
            the laws of the State of Ohio, without regard to its conflict of
            laws principles. Any legal action or proceeding arising under this
            Policy will be brought exclusively in the federal or state courts
            located in Ohio and the parties hereby irrevocably consent to the
            personal jurisdiction and venue therein.
          </p>
          <p>
            <h3>Dispute Resolution</h3>
            Any disputes arising out of or in connection with this Policy shall
            be resolved through binding arbitration in the State of Ohio, in
            accordance with the rules of the American Arbitration Association.
            Judgment on the arbitration award may be entered into any court
            having jurisdiction thereof.
          </p>
          <p>
            <h3>Modifications to Policy</h3>
            We reserve the right, at our sole discretion, to modify, add, or
            remove portions of this Copyright Policy at any time. Changes will
            become effective immediately upon their posting on our Platform.
            Your continued use of our Platform following the posting of changes
            to this Policy will be deemed your acceptance of those changes.
          </p>
          <p>
            <h3>Waiver and Severability</h3>
            No waiver by Pegiora Inc. of any term or condition set
            forth in this Policy shall be deemed a further or continuing waiver
            of such term or condition or a waiver of any other term or
            condition, and any failure of Pegiora Inc. to assert a
            right or provision under this Policy shall not constitute a waiver
            of such right or provision.
          </p>
          <p>
            <h3>Contact Information</h3>
            For any questions, comments, or concerns regarding this Copyright
            Policy, you may contact us at{" "}
            <a
              href="mailto:info@pegiora.com"
              target="_blank"
              style={{ color: "rgb(251, 150, 120)" }}
            >
              info@pegiora.com
            </a>
          </p>
          <p>
            <h3>Entire Agreement</h3>
            This Copyright Policy and any other legal notices published by us on
            the Platform shall constitute the entire agreement between you and
            Pegiora Inc. concerning the use and protection of
            intellectual property related to our Platform.
          </p>
        </div>
      </section>
      <CtaSection />
    </>
  );
};

export default Privacy;
